module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/typography/table-double-scroll/table-double-scroll.component.scss
// module id = ./src/app/features/typography/table-double-scroll/table-double-scroll.component.scss
// module chunks = main